import { Injectable } from '@angular/core';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { StorageService } from 'src/shared/services/storage/storage.service';
import { DEFAULT_API } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {
  private BASE_URL = DEFAULT_API + '/workflow/versions/1';

  constructor(private api: APIHelper, private httpClient: HttpClient, private storage: StorageService) { }

  createWorkflow({ processKey, nodeRef, assignee }: { processKey: string, nodeRef: string, assignee: string }) {
    const datas = {
      processDefinitionKey: processKey,
      variables: {
        bpm_assignee: assignee,
        bpm_sendEMailNotifications: true
      },
      items: [nodeRef]
    }

    return this.api.requestApi({ action: this.BASE_URL + '/processes', method: 'POST', datas })
  }

  sign({ contentSignature, contentParaph, nodeRef, signaturePositions, positionParaph = 'left' }: { contentSignature: string, contentParaph: string, nodeRef: string, signaturePositions?: any, positionParaph?: string }) {
    const formData = new FormData();

    const imageName = 'signature.png';
    const imageBlob = this.dataURLToBlob(contentSignature);
    formData.append('signature-content', imageBlob, imageName);
    formData.append('nodeRef', nodeRef);
    formData.append('signature-positions', JSON.stringify(signaturePositions));
    const imageNameParaph = 'paraph.png';
    const imageBlobParaph = this.dataURLToBlob(contentParaph);
    formData.append('paraph-content', imageBlobParaph, imageNameParaph);
    formData.append('paraph-position', positionParaph);
    const token = this.storage.getAsync({ key: 'token' });
    const args = '?alf_ticket=' + token;

    const url = `${window.location.origin}/alfresco/s/synapture/sign/v1${args}`;

    return this.httpClient.post<any>(url, formData);
  }

  dataURLToBlob(dataURL) {
    // Code taken from
    // https://github.com/szimek/signature_pad/blob/gh-pages/js/app.js
    // which was taken from https://github.com/ebidel/filer.js
    var parts = dataURL.split(';base64,');
    var contentType = parts[0].split(":")[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;
    var uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }
}
